// extracted by mini-css-extract-plugin
export default {"bar":"AppBanner_bar__7DOd0","close":"AppBanner_close__jksde","icon":"AppBanner_icon__XMDVt","text":"AppBanner_text__xyBe8","cta":"AppBanner_cta__yaAER"};